(function () {
  "use strict";

  if (window.__liberGa4ProductTrackingLoaded) return;
  window.__liberGa4ProductTrackingLoaded = true;

  console.log("GA4 product tracking loaded");

  var CONFIG = {
    cardSelector: "product-card.card--product, .card.card--product",
    productLinkSelector: 'a.js-prod-link[href*="/products/"]',
    titleSelector: ".card__title a, .card__title",
    priceSelector: ".price__current",
    visibilityThreshold: 0.5,
    impressionBatchDelay: 200,
    currency: getCurrency()
  };

  var observedCards = new WeakSet();
  var impressedItems = new Set();
  var pendingImpressions = new Map();
  var impressionTimer = null;
  var positionByCard = new WeakMap();

  window.dataLayer = window.dataLayer || [];

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function getCurrency() {
    var shopifyCurrency =
      window.Shopify &&
      window.Shopify.currency &&
      (window.Shopify.currency.active || window.Shopify.currency);

    return (
      shopifyCurrency ||
      (window.meta && window.meta.currency) ||
      document.documentElement.getAttribute("data-currency") ||
      "USD"
    );
  }

  function productPath(link) {
    try {
      return new URL(link.href, window.location.origin).pathname;
    } catch (error) {
      return link.getAttribute("href") || "";
    }
  }

  function productHandle(link) {
    var match = productPath(link).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function productId(card, link) {
    var explicitId =
      card.getAttribute("data-product-id") ||
      card.closest("[data-product-id]")?.getAttribute("data-product-id");

    if (explicitId) return explicitId;

    var variantInput = card.querySelector(
      'input[name*="-color-option"], input[data-variant-id]'
    );
    var inputName = variantInput && variantInput.getAttribute("name");
    var nameMatch = inputName && inputName.match(/-(\d+)-color-option(?:-|$)/);

    return nameMatch ? nameMatch[1] : productHandle(link);
  }

  function parsePrice(card) {
    var priceElement = card.querySelector(CONFIG.priceSelector);
    var text = cleanText(priceElement && priceElement.textContent);
    if (!text || /unavailable/i.test(text)) return undefined;

    var decimalSeparator = ".";
    var lastDot = text.lastIndexOf(".");
    var lastComma = text.lastIndexOf(",");

    if (lastComma > lastDot) decimalSeparator = ",";

    var normalized = text.replace(/[^\d.,-]/g, "");
    if (decimalSeparator === ",") {
      normalized = normalized.replace(/\./g, "").replace(",", ".");
    } else {
      normalized = normalized.replace(/,/g, "");
    }

    var price = Number(normalized);
    return Number.isFinite(price) ? price : undefined;
  }

  function closestList(card) {
    return (
      card.closest(
        "#filter-results, [data-item-list-id], [data-section-id], .shopify-section, section"
      ) || document.body
    );
  }

  function listDetails(card) {
    var list = closestList(card);
    var collectionMatch = window.location.pathname.match(
      /^\/collections\/([^/?#]+)/
    );
    var isSearch = window.location.pathname === "/search";
    var explicitName = list.getAttribute("data-item-list-name");
    var heading = list.querySelector("h1, h2, h3, .section__heading");
    var collectionHeading = document.querySelector(
      "main h1, .collection-banner h1, .main-products-grid h1"
    );

    var name =
      explicitName ||
      (isSearch ? "Search Results" : "") ||
      cleanText(collectionHeading && collectionHeading.textContent) ||
      cleanText(heading && heading.textContent) ||
      (collectionMatch ? collectionMatch[1].replace(/-/g, " ") : "") ||
      "Product List";

    var id =
      list.getAttribute("data-item-list-id") ||
      (isSearch ? "search_results" : "") ||
      (collectionMatch ? "collection_" + collectionMatch[1] : "") ||
      list.id ||
      list.getAttribute("data-section-id") ||
      name.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");

    return { element: list, id: id || "product_list", name: name };
  }

  function cardIndex(card, list) {
    var cards = Array.prototype.filter.call(
      list.element.querySelectorAll(CONFIG.cardSelector),
      function (candidate) {
        return candidate.querySelector(CONFIG.productLinkSelector);
      }
    );
    var index = cards.indexOf(card) + 1;

    if (index > 0) positionByCard.set(card, index);
    return index > 0 ? index : positionByCard.get(card) || 1;
  }

  function itemFromCard(card) {
    var link = card.querySelector(CONFIG.productLinkSelector);
    if (!link) return null;

    var list = listDetails(card);
    var titleElement = card.querySelector(CONFIG.titleSelector);
    var item = {
      item_id: productId(card, link),
      item_name:
        cleanText(titleElement && titleElement.textContent) ||
        cleanText(link.getAttribute("aria-label")) ||
        productHandle(link),
      item_path: productPath(link),
      price: parsePrice(card),
      currency: CONFIG.currency,
      item_list_name: list.name,
      item_list_id: list.id,
      index: cardIndex(card, list)
    };

    if (!item.item_id || !item.item_name) return null;
    if (item.price === undefined) delete item.price;

    return item;
  }

  function impressionKey(item) {
    return [item.item_list_id, item.item_id].join("|");
  }

  function pushEvent(eventName, item, extra) {
    var payload = {
      event: eventName,
      ecommerce: Object.assign(
        {
          currency: item.currency || CONFIG.currency,
          item_list_id: item.item_list_id,
          item_list_name: item.item_list_name,
          items: [item]
        },
        extra || {}
      )
    };

    console.log(
      "[GA4 Product Tracking] 获取到 1 个商品，准备 push 推送",
      {
        event: eventName,
        product: item.item_name,
        payload: payload
      }
    );
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  }

  function flushImpressions() {
    impressionTimer = null;
    if (!pendingImpressions.size) return;

    var groups = new Map();
    pendingImpressions.forEach(function (item) {
      var groupKey = item.item_list_id + "|" + item.item_list_name;
      if (!groups.has(groupKey)) groups.set(groupKey, []);
      groups.get(groupKey).push(item);
    });
    pendingImpressions.clear();

    groups.forEach(function (items) {
      items.sort(function (a, b) {
        return a.index - b.index;
      });

      var payload = {
        event: "view_item_list",
        ecommerce: {
          currency: CONFIG.currency,
          item_list_id: items[0].item_list_id,
          item_list_name: items[0].item_list_name,
          items: items
        }
      };

      console.log(
        "[GA4 Product Tracking] 获取到 " +
          items.length +
          " 个商品，准备 push 推送",
        {
          event: payload.event,
          products: items.map(function (item) {
            return item.item_name;
          }),
          payload: payload
        }
      );
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(payload);
    });
  }

  function queueImpression(card) {
    var item = itemFromCard(card);
    if (!item) return;

    var key = impressionKey(item);
    if (impressedItems.has(key)) return;

    impressedItems.add(key);
    pendingImpressions.set(key, item);

    if (!impressionTimer) {
      impressionTimer = window.setTimeout(
        flushImpressions,
        CONFIG.impressionBatchDelay
      );
    }
  }

  var intersectionObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (
          entry.isIntersecting &&
          entry.intersectionRatio >= CONFIG.visibilityThreshold
        ) {
          queueImpression(entry.target);
          intersectionObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: [CONFIG.visibilityThreshold] }
  );

  function observeCards(root) {
    var cards = [];

    if (root.nodeType === 1 && root.matches(CONFIG.cardSelector)) {
      cards.push(root);
    }

    if (root.querySelectorAll) {
      cards = cards.concat(
        Array.prototype.slice.call(root.querySelectorAll(CONFIG.cardSelector))
      );
    }

    cards.forEach(function (card) {
      if (observedCards.has(card)) return;
      if (!card.querySelector(CONFIG.productLinkSelector)) return;

      observedCards.add(card);
      intersectionObserver.observe(card);
    });
  }

  document.addEventListener(
    "click",
    function (event) {
      var link = event.target.closest(CONFIG.productLinkSelector);
      if (!link) return;

      var card = link.closest(CONFIG.cardSelector);
      if (!card) return;

      var item = itemFromCard(card);
      if (!item) return;

      pushEvent("select_item", item);
    },
    true
  );

  var mutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) observeCards(node);
      });
    });
  });

  function init() {
    observeCards(document);
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
